var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyVoidedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3418_3421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9274 4.55345C15.6345 4.55852 15.4626 4.46879 15.2893 4.22492C13.3752 1.54163 10.773 0.333138 7.53482 0.806404C4.5609 1.24132 2.49498 2.98314 1.3521 5.78655C1.0671 6.48559 0.963266 7.25917 0.776367 7.99874V9.44025C0.799282 9.5307 0.831506 9.62044 0.84368 9.71234C1.11293 11.7494 1.99658 13.4681 3.54835 14.7909C5.75605 16.6724 8.28027 17.1999 11.0508 16.3779C12.8604 15.8409 14.2847 14.7417 15.3302 13.154C15.4655 12.9485 15.6173 12.8812 15.8551 12.8863C16.5919 12.9007 17.3288 12.8913 18.0663 12.8913H19.013V4.54622C17.9682 4.54622 16.9478 4.53464 15.9281 4.55345H15.9274ZM7.51047 16.0558C4.29308 15.5167 1.67864 12.722 1.41225 9.51261C1.11365 5.90667 3.08361 2.82466 6.4349 1.6538C9.42529 0.608848 13.0186 1.82892 14.7673 4.50642C14.3047 4.62871 13.9452 4.55707 13.7748 4.12867C10.571 7.3641 7.39518 10.5713 4.19927 13.7995C4.88171 14.4312 5.68015 14.9103 6.58099 15.2034C9.28709 16.0826 12.0548 15.2953 13.9001 13.1077C14.1586 12.8009 14.4422 12.9188 14.7451 12.9036C13.6474 14.8177 10.7429 16.5979 7.51119 16.0566L7.51047 16.0558ZM11.1239 10.1675C11.2499 10.2196 11.3523 10.3303 11.4654 10.4136C11.4533 10.4418 11.4411 10.47 11.4296 10.4982H11.9209C11.9087 10.4743 11.8965 10.4505 11.8843 10.4266C12.0061 10.3361 12.1164 10.2196 12.251 10.161C12.6599 9.98443 12.9012 9.58498 12.8317 9.15513C12.768 8.76074 12.4006 8.44668 11.9739 8.42859C11.7955 8.42063 11.6065 8.4626 11.4425 8.41267C11.3129 8.37287 11.2148 8.22814 11.1024 8.13045C11.2112 8.03203 11.3193 7.85184 11.4282 7.85112C11.7232 7.84967 12.0662 7.69553 12.2954 8.07979C12.3484 8.1688 12.6219 8.12321 12.8117 8.1413C12.8561 7.77731 12.6806 7.56962 12.4436 7.3945C12.2295 7.23602 11.8435 7.27726 11.9187 6.7765C12.2646 6.3481 12.3083 6.34014 12.8876 6.68822C13.7562 7.20924 14.1937 8.25564 13.9632 9.26151C13.734 10.2638 12.8625 11.0106 11.8314 11.0894C10.846 11.1647 9.88073 10.5568 9.49762 9.63636C9.40166 9.40551 9.42673 9.25065 9.61506 9.07481C9.90149 8.80778 10.1536 8.50312 10.4643 8.16735C10.7193 8.84686 10.9491 9.00678 11.5678 9.01257C11.7103 9.01402 11.8679 8.98146 11.9903 9.03356C12.0992 9.07915 12.2359 9.22026 12.2359 9.31868C12.2359 9.41203 12.072 9.58426 11.9817 9.58353C11.6631 9.57991 11.3 9.75431 11.0458 9.35775C10.9878 9.2673 10.7178 9.31578 10.5453 9.30058C10.5281 9.7232 10.7386 10.0076 11.1239 10.1682V10.1675ZM6.05609 12.8942C8.40916 12.8913 10.7629 12.892 13.116 12.8935C13.1497 12.8935 13.184 12.9036 13.2585 12.9152C11.3802 15.1303 7.70167 15.7584 4.98697 13.6714C5.26123 13.4268 5.51974 13.1851 5.79186 12.9608C5.8563 12.908 5.96658 12.8942 6.05609 12.8942ZM18.4366 12.2668H6.59889C7.37298 11.4846 8.16283 10.6849 8.94623 9.89325C9.88932 11.3572 10.9427 11.9158 12.2667 11.6257C13.4511 11.3659 14.372 10.4121 14.5604 9.24704C14.7909 7.82724 14.2381 6.8011 12.6899 5.88858C12.9492 5.65846 13.184 5.44065 13.4318 5.23802C13.4984 5.18303 13.6022 5.14757 13.6889 5.14757C15.222 5.14323 16.7545 5.1454 18.2876 5.14757C18.332 5.14757 18.3771 5.16855 18.4366 5.18375V12.2668Z",
    fill: "url(#paint0_linear_3418_3421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4082 6.35003H17.2747V7.20104H17.8282V5.78052H16.4082V6.35075V6.35003Z",
    fill: "url(#paint1_linear_3418_3421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2652 11.1088H16.4209V11.6638H17.8223V10.2346H17.2659V11.1088H17.2652Z",
    fill: "url(#paint2_linear_3418_3421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67249 4.17765C1.18193 6.99554 1.59153 11.0957 3.71617 13.2811C6.88988 10.0739 10.0636 6.86673 13.2545 3.64287C10.5956 1.17813 6.26903 1.23964 3.67249 4.17765ZM4.91848 11.1927V5.17339H10.8806C8.89922 7.17355 6.91279 9.17878 4.91848 11.1927ZM11.2953 4.54309C9.12121 4.54671 6.94645 4.54599 4.7724 4.54599H4.31553V5.01274C4.31553 7.11421 4.29978 9.21569 4.32699 11.3164C4.33344 11.802 4.20526 12.1508 3.79995 12.3961C2.40143 10.8403 1.83285 7.38269 3.93959 4.77032C6.01768 2.19341 9.87096 1.7035 12.4696 3.76662C12.1975 4.00976 11.9433 4.25798 11.6648 4.4729C11.5752 4.54165 11.4206 4.54309 11.296 4.54309H11.2953Z",
    fill: "url(#paint3_linear_3418_3421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08941 6.32912H6.94585V5.76685H5.51367V7.19388H6.09012V6.32912H6.08941Z",
    fill: "url(#paint4_linear_3418_3421)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3418_3421",
    x1: 9.89469,
    y1: 0.705933,
    x2: 9.89469,
    y2: 16.7533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3418_3421",
    x1: 17.1182,
    y1: 5.78052,
    x2: 17.1182,
    y2: 7.20104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3418_3421",
    x1: 17.1216,
    y1: 10.2346,
    x2: 17.1216,
    y2: 11.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3418_3421",
    x1: 7.60697,
    y1: 1.87805,
    x2: 7.60697,
    y2: 13.2811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3418_3421",
    x1: 6.22976,
    y1: 5.76685,
    x2: 6.22976,
    y2: 7.19388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3418_3421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2359,
    height: 16.0476,
    fill: "white",
    transform: "translate(0.776855 0.705566)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyVoidedIcon);
export default __webpack_public_path__ + "static/media/money-voided-icon.a102c22cc31ef195515e7cd52c77517b.svg";
export { ForwardRef as ReactComponent };